import * as React from 'react';

import FullPlayer from './FullPlayer';
import PreviewPlayer from './PreviewPlayer';
import YouTubePlayer from './YouTubePlayer';


type PlayerProps = {
  onFinish: Function,
  onProgress: Function,
  owned: Boolean,
  episode: any,
  nextEpisode: any,
}
export default class Player extends React.Component<PlayerProps> {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
    }
  }

  render() {
    const { episode, owned, onFinish } = this.props;

    let playerNode = owned ? <FullPlayer {...this.props} /> : 
      (episode.youtube_id ? <YouTubePlayer {...this.props} /> : <PreviewPlayer {...this.props} /> );

    return (
      <div className="_player">
        {playerNode}
      </div>
    );
  }
}
